export const switchToPlainTextMenuItem = "IeoAc";
export default {switchToPlainTextMenuItem};